import { disableVariantIcon } from '../state/ui-store';

export const disableVariantBttn = () => disableVariantIcon();
